<template>
    <div>
        <div v-if="initImg != false" class="init-img-wrapper">
            <img :src="initImg" alt="">
        </div>
        <h2 id="osp-quizz-start-text">
            {{ startText }}
        </h2>
    </div>
</template>

    <script>
// import Something from '.something'

import { TimelineLite, TweenLite }  from 'gsap/all';

import {CSSPlugin} from 'gsap/CSSPlugin';
import {AttrPlugin} from 'gsap/AttrPlugin';
import {TextPlugin} from 'gsap/TextPlugin';

var  plugins = [ CSSPlugin, AttrPlugin, TextPlugin ];

export default {

    data : function () {
        return {
        };
    },
    methods : {},
    computed : {
        startText: function () {
            return this.$store.state.startText;
        },
        initImg: function () {
            return this.$store.getters.initImg;
        }
    },
    watch : {
        startText : function (newVal, oldVal) {
            if ( newVal != '' ) {
                var el = document.getElementById('osp-quizz-start-text');
                el.textContent = '';
                TweenLite.to(el, 4, {text: newVal, ease: Linear.easeIn, onComplete: function () {
                    let startBtn = document.getElementById('startButton');
                    startBtn.scrollIntoView();
                }},);
            }
        },
    },

}
</script>

<style lang="scss" scoped>
</style>
